import { render, staticRenderFns } from "./ModalConfirmChangeName.vue?vue&type=template&id=6a68e516&scoped=true&"
import script from "./ModalConfirmChangeName.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmChangeName.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmChangeName.vue?vue&type=style&index=0&id=6a68e516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a68e516",
  null
  
)

export default component.exports